export const PC_SIMULATION_START = 'PC_SIMULATION_START';
export const PC_SIMULATION_END = 'PC_SIMULATION_END';
export const PC_SIMULATION_RESULT = 'PC_SIMULATION_RESULT';
